<template>
  <teleport v-if="widget" :to="teleport">
    <div
      class="orm-py-56 orm-py-sm-70 orm-container-fluid orm-background__image"
      v-if="clientdata"
      :style="{
        backgroundImage: 'url(' + backgroundImage + ')',
      }"
    >
      <div class="orm-container">
        <div class="orm-row center-xs">
          <div class="orm-col-xs-12 text-center">
            <h2
              class="orm-searchbar__title orm-headline__h1 orm-pb-sm-128"
              :class="
                headlinemode == 'dark' ? 'orm-searchbar__title--dark' : ''
              "
            >
              <span v-html="i18n('modules/searchbar/title')"></span>
            </h2>
          </div>
        </div>
        <div class="orm-row center-xs">
          <div
            class="orm-carsearchfilter__types orm-searchbar__tabs orm-col-xs-12 orm-col-sm-11 orm-col-md-11 orm-col-lg-11 hide-mobile-only"
          >
            <div
              class="orm-carsearchfilter__typescontainer orm-flex"
              v-if="sttype == 'ALL' && tabbar.length > 1"
            >
              <div
                class="orm-carsearchfilter__typesitem"
                :class="
                  station === stationtype ||
                  (stationtype === 'ALL' && station === 'RENT')
                    ? 'active'
                    : ''
                "
                @click="setStationType(station)"
                v-for="station in tabbar"
                :key="station"
              >
                {{ i18n("general/stationtype/" + station) }}
              </div>
            </div>
          </div>
          <div
            class="orm-searchbar__datepicker orm-col-xs-12 orm-col-sm-11 orm-col-md-11 orm-col-lg-11"
            :class="
              sttype == 'ALL' && tabbar.length > 1
                ? 'orm-searchbar__datepicker_' + sttype
                : ''
            "
          >
            <div class="orm-searchbar__padding" v-if="ormload">
              <div class="orm-row center-lg">
                <FormSelect
                  v-if="
                    sttype == 'ALL' &&
                      tabbar &&
                      stationsFilter &&
                      tabbar.length > 1
                  "
                  :data="tabbar"
                  :selected="stationtype"
                  v-model="stationtype"
                  @update:modelValue="setStationType(stationtype)"
                  class="orm-col-xs-12 orm-col-sm-6 orm-col-lg-12 show-mobile-only"
                ></FormSelect>
                <span
                  v-if="
                    stationtype == 'ABO' &&
                      store.getters['ORMgeneral/GET_PARAMETER'](
                        'BORM_ABO_ALL_STAT'
                      ) === '1'
                  "
                >
                </span>
                <div class="orm-col-xs-12 orm-col-md-12" :class="showDriveReason ? 'orm-col-lg-6' : 'orm-col-lg-3'" v-else>
                  <div class="orm-searchbar__headline">
                    <strong>{{ i18n("general/station") }}</strong>
                  </div>
                  <div class="orm-row">
                    <stationpicker
                      :data="stations"
                      type="start"
                      class="orm-col-xs-12 orm-col-sm-6 orm-col-lg-12"
                    />
                    <stationpicker
                      v-if="
                        store.getters['ORMgeneral/GET_PARAMETER'](
                          'BINET_ALLOW_ONEWAY'
                        ) == 1 && stationtype != 'ABO'
                      "
                      :data="stations"
                      type="end"
                      class="orm-col-xs-12 orm-col-sm-6 orm-col-lg-12"
                    />
                  </div>

                </div>

                <div class="orm-col-xs-12 orm-col-md-12 orm-col-lg-6" v-if="showDriveReason">
                  <div class="orm-searchbar__headline">
                    <strong>{{ i18n('form/label/driveReason') || 'Fahrtgrund' }}</strong>
                  </div>
                  <FormSelect2
                      my-id="formDriveReason"
                      :my-label="''"
                      :my-options="driveReasonsWithPlaceholder"
                      my-options-value="id"
                      my-options-text="reason"
                      :my-placeholder="i18n('form/placeholder/driveReason') || 'Grund auswählen'"
                      :is-required="true"
                      v-model="driveReason"
                      @update:modelValue="onDriveReasonChange"
                      class="orm-searchbar__select"
                  ></FormSelect2>
                </div>

                <div
                  class="orm-col-xs-12"
                  :class="showDriveReason ? 'orm-col-lg-10' : 'orm-col-lg-7'"
                  style="position: relative"
                >
                  <datepicker 
                    v-if="stationtype != 'ABO'" 
                    :class="{ 'disabled': showDriveReason && !isDriveReasonSelected }" 
                    :style="{ 'pointer-events': (showDriveReason && !isDriveReasonSelected) ? 'none' : 'auto', 'opacity': (showDriveReason && !isDriveReasonSelected) ? '0.5' : '1' }" 
                  />
                  <datepicker_abo 
                    v-else 
                    :class="{ 'disabled': showDriveReason && !isDriveReasonSelected }" 
                    :style="{ 'pointer-events': (showDriveReason && !isDriveReasonSelected) ? 'none' : 'auto', 'opacity': (showDriveReason && !isDriveReasonSelected) ? '0.5' : '1' }" 
                  />
                  <div
                    style="display: flex"
                    v-if="store.getters['ORMgeneral/GET_PARAMETER']('BORM_PRESELECT_PLANNED_KM') === '1' && stationtype != 'ABO'"
                  >
                    <div class="orm-pl-sm-8 orm-datecol orm-km-container">
                      <p
                          class="orm-searchbar__headline orm-searchbar__headline--label orm-mr-16"
                          style="transform: translateY(0)"
                      >
                        {{
                          i18n("general/plannedDistance") ||
                          "Geplante Kilometer: "
                        }}
                      </p>
                      <KmInput class="orm-dateselect " />
                    </div>

                  </div>
                </div>
                <div
                  class="text-right orm-col-xs-12 orm-col-sm-6 orm-col-sm-offset-6"
                  :class="showDriveReason ? 'orm-col-lg-2 orm-col-lg-offset-0' : 'orm-col-lg-2 orm-col-lg-offset-0'"
                >
                  <div class="orm-searchbar__headline">
                    <strong>&nbsp;</strong>
                  </div>
                  <button
                    v-if="!loading"
                    @click="getCars('/reservation/step1')"
                    class="orm-btn orm-btn--large orm-btn--searchbar"
                    :class="[station && (!showDriveReason || isDriveReasonSelected) ? '' : 'disable']"
                  >
                    {{ i18n("general/search") }}
                  </button>
                  <button
                    class="orm-btn orm-btn--large orm-btn--searchbar disable"
                    v-else
                  >
                    <i class="fa fa-spinner-third orm-rotate360"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import { defineComponent } from "vue";
import FormSelect from "@/components/ui/INPUTS/FormSelectSimpleArray"; // @ is an alias to /src
import FormSelect2 from "@/components/ui/INPUTS/FormSelect.vue"; // @ is an alias to /src
import datepicker from "@/components/ui/datepicker.vue"; // @ is an alias to /src
import datepicker_abo from "@/components/ui/datepicker_abo.vue"; // @ is an alias to /src
import stationpicker from "@/components/ui/stationpicker.vue"; // @ is an alias to /src
import KmInput from "@/components/ui/km-input.vue";
import store from "@/store";
import i18n from "@/mixins/mixins";
import { buildDataLayer } from "@/constants/analytics";
import { routeToSteps } from "@/constants/getRoutes";
// import routes from "@/router/index";

export default defineComponent({
  name: "SearchBarWrapped",
  components: {
    datepicker,
    datepicker_abo,
    stationpicker,
    FormSelect,
    FormSelect2,
    KmInput,
  },
  mixins: [i18n],
  setup() {
    let widget = false;
    const myEle = document.getElementById("crentSearchBar");
    const env = process.env;
    let headlinemode = "dark";
    let teleport;
    let sttype = "ALL";
    if (myEle !== null) {
      sttype = document.getElementById("crentReservation").dataset.stationtype;

      if (
        !store.getters["userSession/GET_STATIONTYPE"] ||
        (sttype !== "ALL" &&
          sttype !== !store.getters["userSession/GET_STATIONTYPE"])
      ) {
        store.dispatch("userSession/SET_STATIONTYPE", sttype);
        if (store.getters['ORMgeneral/GET_PARAMETER'](
            'BORM_PRESELECT_STATION'
        ) === '1'){
          store.dispatch(
              "userSession/SET_STATION",
              store.getters["stations/GET_STATIONS_FILTERED"][sttype][0].id
          );
        }
      }

      if (document.getElementById("crentReservation").dataset.stationid) {
        const stationid = document.getElementById("crentReservation").dataset
          .stationid;
        store.dispatch("userSession/SET_STATION", stationid);
      }

      widget = true;
      headlinemode = myEle.dataset.headline;
      teleport = "#crentSearchBar";
    }
    // if (myEle !== null) {
    //   myEle.forEach((element) => {
    //     sttype = element.dataset.stationtype;
    //     if (element.dataset.stationtype) {
    //       if (element.dataset.stationtype == "ALL") {
    //         store.dispatch("userSession/SET_STATIONTYPE", "RENT");
    //       } else {
    //         store.dispatch(
    //           "userSession/SET_STATIONTYPE",
    //           element.dataset.stationtype
    //         );
    //       }
    //       widget = true;
    //       headlinemode = element.dataset.headline;
    //       teleport =
    //         "[data-searchbar-stationtype=" + element.dataset.stationtype + "]";
    //     }
    //   });
    // }

    return {
      widget,
      store,
      headlinemode,
      teleport,
      sttype,
      env,
    };
  },
  props: {
    type: { required: false, default: "ALL" },
    origin: {
      type: String,
      default: "home",
      required: false,
    },
  },
  data() {
    return {
      station: Object,
      loading: false,
      ormload: false,
      clientdata: null,
      backgroundImage: "",
      stations: {},
      stationsFilter: {},
      stationtype: null,
      tabbar: [],
      driveReasons: [],
      driveReason: null
    };
  },
  computed: {
    showDriveReason() {
      return process.env.VUE_APP_DRIVE_REASON === 'true';
    },
    isDriveReasonSelected() {
      if (!this.showDriveReason) return true;
      return this.driveReason && this.driveReason !== null && this.driveReason !== "";
    },
    driveReasonsWithPlaceholder() {
      return [
        { id: "", reason: this.i18n('form/placeholder/driveReason') || 'Grund auswählen' },
        ...this.driveReasons
      ];
    }
  },
  async mounted() {
    // Fahrtgrund zurücksetzen beim Start
    if (this.showDriveReason) {
      await store.dispatch('userSession/SET_DRIVE_REASON', null);
    }
    
    this.loading = false;
    this.ormload = await store.getters["general/GET_ORMLOADED"];
    this.stations = await store.getters["stations/GET_STATIONS"];
    this.stationsFilter = await store.getters["stations/GET_STATIONS_FILTERED"];
    this.stationtype = await store.getters["userSession/GET_STATIONTYPE"];

    if (this.showDriveReason) {
      this.driveReasons = await store.getters[
          "ORMgeneral/GET_DRIVE_REASONS"
          ]();
    }
    
    // Kein Standard-Fahrtgrund - Feld bleibt leer

    for (const station in this.stationsFilter) {
      if (station !== "ALL") this.tabbar.push(station);
    }

    if (this.stationtype === "ALL") this.stationtype = "RENT";

    this.stations = this.stationsFilter[this.stationtype];
    this.station = await store.getters["userSession/GET_STATION"];
    // if (!this.station) this.station = this.stations[0].id;
    this.clientdata = await store.getters["general/GET_CLIENT_DATA"];
    const GET_ORMIMAGE = await store.getters["general/GET_ORMIMAGE"](
      "searchbarbg"
    );
    if (GET_ORMIMAGE) {
      this.backgroundImage = GET_ORMIMAGE;
    }
    // eslint-disable-next-line
    else if (this.clientdata["searchbar_background"]) {
      if (this.clientdata["searchbar_background"].search("http") != "-1") {
        // eslint-disable-next-line
        this.backgroundImage = this.clientdata["searchbar_background"];
      } else {
        // eslint-disable-next-line
        this.backgroundImage =
          process.env.VUE_APP_BASE_URL +
          this.clientdata["searchbar_background"];
      }
    }
    if (document.getElementById("crentSearchBar")) {
      if (
        document.getElementById("crentSearchBar").dataset.image != "" &&
        document.getElementById("crentSearchBar").dataset.image
      ) {
        this.backgroundImage = document.getElementById(
          "crentSearchBar"
        ).dataset.image;
      }
    }
    store.watch(
      // eslint-disable-next-line
      (state, getters) => getters["general/GET_ORMLOADED"],
      (val) => {
        this.ormload = val;
        this.stations = store.getters["stations/GET_STATIONS"];
      }
    );

    store.watch(
      // eslint-disable-next-line
      (state, getters) => getters["userSession/GET_STATION"],
      (val) => {
        this.station = store.getters["stations/GET_STATION_BY_ID"](val);
      }
    );
    store.watch(
      // eslint-disable-next-line
      (state, getters) => getters["userSession/GET_STATIONTYPE"],
      (val) => {
        this.stationtype = val;
        this.stations = this.stationsFilter[this.stationtype];
      }
    );
  },
  methods: {
    async getCars() {
      const times = await store.getters["stations/GET_OPENINGTIMES"];
      if (times) {
        await store.dispatch("userSession/SET_CARGROUP_ABO", null).then(() => {
          store.dispatch("userSession/SET_ABO_VEHICLEGROUP", null).then(() => {
            this.loading = true;
            buildDataLayer("orm_reservation_begin", {}, "searchbar");
            routeToSteps(this, 1);
          })
        })
      }
    },
    async setStationType(type) {
      this.stationtype = type;
      await store.dispatch("userSession/SWITCH_STATIONTYPE", type).then(() => {
        if (this.stationtype === "ABO") {
          store.dispatch("reservation/SET_DRIVEDISTANCE", null);
        }
        if (store.getters['ORMgeneral/GET_PARAMETER'](
            'BORM_PRESELECT_STATION'
        ) === '1') {
          store.dispatch(
              "userSession/SET_STATION",
              this.stationsFilter[type][0].id
          );
        }
        store.dispatch("userSession/SET_STATION_END", "startend");

        this.stations = this.stationsFilter[type];
      });
    },
    async onDriveReasonChange(reasonIdOrEvent) {
      // Handle both Event objects and direct values
      let reasonId = reasonIdOrEvent;
      if (reasonIdOrEvent && reasonIdOrEvent.target) {
        reasonId = reasonIdOrEvent.target.value;
      }
      
      // Convert to number if needed (API might return numbers)
      const reasonIdNum = parseInt(reasonId);
      const selectedReason = this.driveReasons.find(reason => 
        reason.id === reasonId || reason.id === reasonIdNum
      );
      
      if (selectedReason) {
        // Speichere nur den Fahrtgrund im Store
        await store.dispatch('userSession/SET_DRIVE_REASON', selectedReason);
        
        // Lade die Öffnungszeiten neu - diese werden dann durch die Fahrtgrund-Logik angepasst
        const currentStation = await store.getters['userSession/GET_STATION'];
        await store.dispatch('stations/SET_OPENINGTIMES', currentStation || 'preload');
      }
    },
  },
});
</script>
